/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "88")


  
    
export interface API44997Item {
  
  /** Node */
  next?: any;
  
};
    
  



export interface API44997Req {
  
  /** (String) */
  resourceFlag?: string;
    
};



export interface API44997Res {
  /** :Node  */
  table?: API44997Item[];
  /** Entry  */
  entrySet?: API44997Item[];
  /**   */
  size?: number;
  /**   */
  modCount?: number;
  /**   */
  threshold?: number;
  /** K  */
  keySet?: API44997Item[];
  /** Collection  */
  values?: any;
  
};


// 44997 校验用户是否有该资源的数据权限

export interface IUseGetAPI44997Return {
  /** 校验用户是否有该资源的数据权限: 接口请求状态 */
  isAPI44997Loading: boolean;
  /** 校验用户是否有该资源的数据权限: 接口请求返回数据 */
  dataAPI44997: API44997Res;
  /**  校验用户是否有该资源的数据权限: 接口数据请求方法 */
  fetchAPI44997Data:  (inputs: API44997Req, config?: YWRequestConfig) => Promise<API44997Res>;
  /** 校验用户是否有该资源的数据权限: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI44997 = ():IUseGetAPI44997Return => {
  let isMount = true;
  const [isAPI44997Loading, setIsAPI44997Loading] = useState(false);
  const [dataAPI44997, setDataAPI44997] = useState<API44997Res>({} as API44997Res);
  const requestUrl = `${basePath}/ywwl-admin/new/resource/checkPathDataPermission`;

  const fetchAPI44997Data = async (inputs: API44997Req, config?: YWRequestConfig): Promise<API44997Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API44997Req>) || {}) as API44997Req;
    
  
    if ( isMount ) {
      setIsAPI44997Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API44997Res>(`${basePath}/ywwl-admin/new/resource/checkPathDataPermission?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI44997(res || {} as API44997Res);
        setIsAPI44997Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI44997Loading(false);
      }
      return false as unknown as API44997Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI44997Loading,
    dataAPI44997,
    fetchAPI44997Data,
    requestUrl,
  }
}

